/* eslint-disable react/prop-types */

import React from 'react';
import HashtagBadge from './hashtag_badge';
import HashtagActionButtons from './hashtag_action_buttons';

function HashtagRow({
 hashtag, hashtagUsageCeiling, onFollow, onMute, onBlock, onRemoveForceFollow,
}) {
  const highFrequency = !(hashtagUsageCeiling && hashtag.hashtag_usage_count >= hashtagUsageCeiling);

  return (
    <tr>
      <td className="fw-bold">{hashtag.hashtag_name}</td>
      <td>
        <HashtagBadge usageCount={hashtag.hashtag_usage_count} />
        {!highFrequency && (
          <span className="ms-2 text-danger small">
            <i className="fa-solid fa-triangle-exclamation" /> Exceeds notification frequency
          </span>
        )}
      </td>
      <td className="text-end">
        <HashtagActionButtons
          hashtag={hashtag}
          hashtagUsageCeiling={hashtagUsageCeiling}
          onFollow={onFollow}
          onMute={onMute}
          onBlock={onBlock}
          onRemoveForceFollow={onRemoveForceFollow}
        />
      </td>
    </tr>
  );
}

export default HashtagRow;
